module.exports = __webpack_public_path__ + "static/media/mouton_01_thumb.04cdbee8.png";